import { times } from 'lodash/fp';

const getPaginationRange = (start: number, end: number) => {
  const amountToIterate = end - start + 1;
  return times((i) => start + i, amountToIterate);
};

export default getPaginationRange;
